/**
 * Određivanje cilja strelice „nazad" u zaglavlju (mobilni prikaz).
 *
 * Na mobilnom prikazu se hamburger dugme na „detalj" stranicama zamenjuje
 * strelicom „nazad" (vidi HeaderBackButton / Shell). Ovde je jedinstveno mesto
 * gde se, na osnovu trenutne putanje, zna da li je takva stranica otvorena i
 * gde strelica treba da vodi.
 *
 * Vraća putanju na koju „nazad" vodi, ili `null` kada stranica nije „detalj"
 * (tada u zaglavlju ostaje hamburger, kao i do sada).
 */

const RESIDENTS_LIST = '/residents';
const EMPLOYEES_LIST = '/employees';

// Segmenti ispod /residents koji NISU profil pojedinačnog rezidenta
// (liste/dodavanje) - tu „nazad" ne zamenjuje hamburger.
const RESIDENTS_LIST_SEGMENTS = ['add', 'inactive', 'groups'];

export const getHeaderBackTarget = (pathname) => {
  if (typeof pathname !== 'string' || pathname.length === 0) return null;

  // Profil rezidenta: /residents/<id> i njegovi pod-tabovi
  // (/health, /schedule, /nutrition, /family, /finances).
  // „Nazad" vodi na listu rezidenata.
  const residentMatch = pathname.match(/^\/residents\/([^/]+)/);
  if (residentMatch && !RESIDENTS_LIST_SEGMENTS.includes(residentMatch[1])) {
    return RESIDENTS_LIST;
  }

  // Profil zaposlenog: /employees/<id>. „Nazad" vodi na listu zaposlenih.
  const employeeMatch = pathname.match(/^\/employees\/([^/]+)/);
  if (employeeMatch && employeeMatch[1] !== 'inactive') {
    return EMPLOYEES_LIST;
  }

  return null;
};

export default getHeaderBackTarget;
